<template>
  <formulario-contacto tipo="feedback" />
</template>

<script>
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto";

export default {
  name: "AgradecimientoSugerencia",
  components: {
    FormularioContacto
  }
};
</script>
